import React, { useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { FaCheck } from 'react-icons/fa'

import Yup from '~/services/yup'
import { api } from '~/services/api'

import ActionFooter from '~/components/ActionFooter'
import {
    Button, Textbox, Select, Checkbox
} from '~/components/Form'
import Modal from '~/components/Modal'

import { Container, TermoContainer, ModalTermoContainer } from './styles'

const initialValues = {
    instituicao: '',
    matricula: '',
    autorizado: false
}

const validation = Yup.object({
    instituicao: Yup.string().required('Selecione a instituição.'),
    matricula: Yup.string().required('Digite a matrícula.'),
    autorizado: Yup.boolean()
})

export default function ({ onSubmit, valorMensalidade }) {
    const [instituicoes, setInstituicoes] = useState([])
    const [showTermoCiencia, setShowTermoCiencia] = useState(false)

    useEffect(() => {
        async function loadInstituicoes() {
            const response = await api.get('instituicao')
            const instituicoesIds = [13186]
            // const instituicoesIds = [13636, 17755]

            setInstituicoes(response.filter(instituicao => instituicao.desconto && !['banco', 'microempresa'].includes(instituicao.tipo_instituicao.descricao) && (instituicoesIds.includes(instituicao.id))))
        }

        loadInstituicoes()
    }, [])

    return (
        <Container>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ isSubmitting, setFieldValue }) => (
                    <Form>
                        <Select
                            name="instituicao"
                            label="Instituicao"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={instituicoes.map(instituicao => ({
                                label: instituicao.nome_fantasia,
                                value: instituicao.id
                            }))}
                            containerClass="instituicao-container"
                        />

                        <Textbox
                            label="Matrícula"
                            name="matricula"
                        />

                        <TermoContainer>
                            <Button onClick={() => setShowTermoCiencia(true)} className="transparent">
                                VER TERMO DE CIÊNCIA
                            </Button>
                        </TermoContainer>

                        <Checkbox
                            name="autorizado"
                            label={`Li e concordo com o Termo de Ciência acima e autorizo o desconto da mensalidade através de débito em meu contra-cheque, no dia 10 de cada mês, com valor correspondente a R$ ${valorMensalidade.toFixed(2).replace('.', ',')} em favor do Sindicato dos Médicos do Pará. Estou ciente que este valor será reajustado anualmente no mês de janeiro.`}
                            handleChange={e => { setFieldValue(e.target.name, e.target.checked) }}
                            containerStyle={{ gridArea: 'check' }}
                        />

                        <ActionFooter>
                            <Button type="submit" loading={isSubmitting} className="white">
                                Concluir
                                <FaCheck />
                            </Button>
                        </ActionFooter>
                    </Form>
                )}
            </Formik>

            <Modal
                isOpen={showTermoCiencia}
                handleClose={() => setShowTermoCiencia(false)}
                title="Termo de Ciência do Associado"
            >
                <ModalTermoContainer>
                    <iframe src={`${process.env.REACT_APP_BACKEND_URL}/resources/TERMO DE CIENCIA SINDMEPA.pdf`} frameBorder="0" title="Termo de Ciência" />
                </ModalTermoContainer>
            </Modal>
        </Container>
    )
}
